import { getMyShippingOrigin, saveShippingOrigin } from './api';
import { isValidCanadianPostalCode, normalizeCanadianPostalCode } from './shipping';

/** Read an existing profile postal code for compatibility, without publishing new origin data. */
export const getProfileShipFromPostalCode = user => {
  const profile = user?.attributes?.profile;
  return normalizeCanadianPostalCode(
    profile?.publicData?.shipFromPostalCode || profile?.privateData?.shipFromPostalCode || ''
  );
};

/**
 * Seed missing legacy rating postal codes only. Never overwrite a backend origin from stale
 * profile data, or publish private addresses/postal codes back to publicData.
 */
export const syncShippingOriginFromProfile = user => {
  const postalCode = getProfileShipFromPostalCode(user);
  if (!isValidCanadianPostalCode(postalCode)) return Promise.resolve(null);
  return getMyShippingOrigin()
    .then(current =>
      current?.postalCode
        ? current.postalCode
        : saveShippingOrigin(postalCode).then(() => postalCode)
    )
    .catch(() => {
      console.warn('Shipping origin sync failed.');
      return null;
    });
};
